import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "navigation",
    component: () => import("@/views/Navigation/"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/"),
  },
  {
    path: "/relogin",
    name: "relogin",
    component: () => import("@/views/ReLogin/"),
  },
  {
    path: "/standalone",
    name: "homeStandalone",
    component: () => import("@/views/HomeStandalone/"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/Policy/"),
  },
  {
    path: "/clause",
    name: "clause",
    component: () => import("@/views/Clause/"),
  },
  {
    path: "/404",
    name: "notFound",
    component: () => import("@/views/NotFound/"),
  },
  {
    path: "/home",
    name: "home",
    redirect: "/home/map",
    component: () => import("@/views/Home/"),
    children: [
      {
        path: "map",
        name: "map",
        component: () => import("@/views/Map/"),
        meta: {
          root: true,
        },
      },
      {
        path: "post",
        name: "post",
        component: () => import("@/views/Post/"),
        meta: {
          root: true,
        },
      },
      {
        path: "queue",
        name: "queue",
        component: () => import("@/views/Queue/"),
        meta: {
          root: true,
        },
      },
      {
        path: "history/record",
        name: "record",
        component: () => import("@/views/Record/"),
        meta: {
          root: true,
        },
      },
      {
        path: "history/fail",
        name: "fail",
        component: () => import("@/views/FailPost/"),
        meta: {
          root: true,
        },
      },
      {
        path: "authorize/page",
        name: "pageAuthorize",
        component: () => import("@/views/Authorize/PageAuthorize/"),
        meta: {
          root: true,
        },
      },
      {
        path: "authorize/user",
        name: "userBinding",
        component: () => import("@/views/Authorize/UserBinding/"),
        meta: {
          root: true,
        },
      },
      {
        path: "authorize/business",
        name: "businessAuthorize",
        component: () => import("@/views/Authorize/Business/"),
        meta: {
          root: true,
        },
      },
      {
        path: "page",
        name: "page",
        component: () => import("@/views/MyPage/"),
        meta: {
          root: true,
        },
      },
      {
        path: "user",
        name: "user",
        component: () => import("@/views/User/"),
        meta: {
          root: true,
          admin: "1",
        },
      },
      {
        path: "realization/list",
        name: "businessList",
        component: () => import("@/views/Realization/BusinessList/"),
        meta: {
          root: true,
        },
      },
      {
        path: "realization/overview",
        name: "overview",
        component: () => import("@/views/Realization/Overview/"),
        meta: {
          root: true,
        },
      },
      {
        path: "realization/income",
        name: "income",
        component: () => import("@/views/Realization/Income/"),
        meta: {
          root: true,
        },
      },
      {
        path: "realization/member",
        name: "incomeMember",
        component: () => import("@/views/Realization/Member/"),
        meta: {
          root: true,
          admin: "1",
        },
      },
      {
        path: "realization/comparison",
        name: "comparison",
        component: () => import("@/views/Realization/Comparison/"),
        meta: {
          root: true,
          admin: "4",
        },
      },
      {
        path: "realization/comparisonbackup",
        name: "comparisonbackup",
        component: () => import("@/views/Realization/ComparisonBackUp/"),
        meta: {
          root: true,
          admin: "4",
        },
      },
      {
        path: "performance/:id",
        name: "performance",
        component: () => import("@/views/Performance/"),
        meta: {
          root: true,
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: () => ({ y: 0 }),
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.root) {
    let user = store.state.loginUser.user;
    const checkAdmin = (user) => {
      if (to.meta.admin) {
        if (to.meta.admin === user.role || user.role === "4") {
          next();
        } else {
          next({ path: "/home/map" });
        }
      } else {
        next();
      }
    };
    if (user) {
      checkAdmin(user);
    } else {
      const hasToken = localStorage.getItem("userInfo");
      if (hasToken) {
        try {
          await store.dispatch("loginUser/resLogin");
          user = store.state.loginUser.user;
          checkAdmin(user);
        } catch (error) {
          console.log(error);
          localStorage.removeItem("userInfo");
          //next({ path: '/login', query: { returnUrl: to.fullPath } })
        }
      } else {
        next({ path: "/login", query: { returnUrl: to.fullPath } });
      }
    }
  } else {
    next();
  }
});

export default router;
